import React from 'react';

import Chip from "@mui/joy/Chip";
import Link from "@mui/joy/Link";
import Typography from "@mui/joy/Typography";

// components
import CommonInfoTab from "../Common/CommonInfoTab";

// icons
import ContactPageIcon from '@mui/icons-material/ContactPage';



class ContactCard extends React.Component {
    render() {
        if (this.props.mini){
            return (
                <Chip
                    startDecorator={<ContactPageIcon />}
                >
                    {
                        this.props.hideLink?
                            <Typography
                                size={'body-sm'}
                            >
                                {this.props.contact.first_name} {this.props.contact.patronymic} {this.props.contact.last_name}
                            </Typography>:
                            <Link
                                href={'/contact/detail/'+this.props.contact.id}
                                target={'_blank'}
                                fontSize={'small'}
                            >
                                {this.props.contact.first_name} {this.props.contact.patronymic} {this.props.contact.last_name}
                            </Link>
                    }
                </Chip>
            )
        }
        return(
            <CommonInfoTab
                groups={
                    [
                        {
                            title: `${this.props.contact.first_name} ${this.props.contact.patronymic} ${this.props.contact.last_name}`,
                            icon: <ContactPageIcon/>,
                            linkPattern: '/contact/detail/:linkParam',
                            linkParam: this.props.contact.id,
                            fields: [
                                {
                                    title: 'Должность',
                                    value: this.props.contact.role,
                                },
                                {
                                    title: 'Пол',
                                    value: this.props.contact.sex_human,
                                },
                            ]
                        }
                    ]
                }
            />
        )
    }
}

export default ContactCard